import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ReadonlyDataSource } from '../../../table-datasouces/readonly.datasource';
import { FeeService } from '../../services/fee.service';
import { Invoice } from '../../../dto/invoice';

@Component({
  selector: 'app-fees',
  templateUrl: './fees.component.html',
  styleUrls: ['./fees.component.scss']
})
export class FeesComponent  {
  feeColumns = [
    { columnDef: 'date', header: 'Date', 
      cell: (row: Invoice) =>  `${this.datePipe.transform(row.creationDate, 'dd.MM.yyyy HH:mm')}`},
    { columnDef: 'code', header: 'Invoice code', cell: (row: Invoice) => `${row.code}` , class: 'center'},
    { columnDef: 'billAmount', header: 'Bill Amount', cell: (row: Invoice) => `${row.billAmount}` , class: 'center'},
    { columnDef: 'outstandingAmount', header: 'Outstanding Amount', cell: (row: Invoice) => `${row.outstandingAmount}` , class: 'center'},
  ];
  feeDataSource = new ReadonlyDataSource<Invoice>(this.feeService);

  constructor(
    private datePipe: DatePipe,
    private feeService: FeeService,
  ) { }

  getViewLink = (item: Invoice): string => '/cards/' + item.cardId.toString();
}
